import { render } from "./AgentDashboardNav.vue?vue&type=template&id=1f35cd70"
import script from "./AgentDashboardNav.vue?vue&type=script&lang=js"
export * from "./AgentDashboardNav.vue?vue&type=script&lang=js"

import "./AgentDashboardNav.vue?vue&type=style&index=0&id=1f35cd70&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__